import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/savings-rate-calculator',
  component: () => import('../../routes/SavingsRateCalculator.svelte'),
  card: {
    id: 'savings-rate-calculator',
    title: 'Savings Rate Calculator',
    description: 'Calculate your savings rate and see how many years until you reach financial independence (FIRE). Uses compound growth with annual contributions.',
    icon: 'savings',
    iconBgClass: 'bg-green-50',
    iconTextClass: 'text-green-600',
    href: '/savings-rate-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Savings Rate Calculator – How Long Until FIRE?',
    description: 'Free savings rate calculator. Enter your income and expenses to find your savings rate, FIRE number, and years to financial independence using compound growth.',
  },
};

export default meta;